import { QueryHookOptions } from '@apollo/client';
import { PaginationInfo, usePaginatedQuery } from '@occc-app/hooks/usePaginatedQuery';
import {
  AudienceBroadcastMessagesFilter,
  MessagingCampaignsListQuery,
  MessagingCampaignsListQueryVariables,
  useMessagingCampaignDetailsQuery,
  useMessagingCampaignsListQuery,
} from '@occc/graphql';
import { mapEdgesToMessagingCampaignDetails, mapEdgesToMessagingCampaignsArray } from './utils';

export type UseGetMessagingCampaignsListParams = {
  filter: AudienceBroadcastMessagesFilter;
  pageSize?: number;
  baseOptions?: QueryHookOptions<MessagingCampaignsListQuery, MessagingCampaignsListQueryVariables>;
  paginationInfo?: PaginationInfo;
  onPageChange?: (info: PaginationInfo) => void;
};

export const useGetMessagingCampaignsList = ({
  filter,
  baseOptions,
  pageSize,
  paginationInfo,
  onPageChange,
}: UseGetMessagingCampaignsListParams) => {
  const response = usePaginatedQuery(
    useMessagingCampaignsListQuery,
    'messagingCampaignsList.pageInfo',
    pageSize,
    {
      fetchPolicy: 'cache-and-network',
      notifyOnNetworkStatusChange: true,
      ...baseOptions,
      variables: {
        ...baseOptions?.variables,
        filter,
      },
    },
    paginationInfo,
    onPageChange,
  );

  return {
    ...response,
    data: response.data
      ? mapEdgesToMessagingCampaignsArray(response.data.messagingCampaignsList.edges)
      : response.data,
  };
};

export const useGetMessagingCampaignById = (campaignId?: string) => {
  const response = usePaginatedQuery(useMessagingCampaignDetailsQuery, 'campaign.pageInfo', 1, {
    notifyOnNetworkStatusChange: true,
    variables: {
      filter: {
        uuidEquals: campaignId,
      },
    },
    skip: !campaignId,
  });

  return {
    ...response,
    data: response.data
      ? mapEdgesToMessagingCampaignDetails(response.data.campaign.edges)
      : response.data,
  };
};
